import React from "react";
const DEFAULT_CONFIG = {
    initialValue: [],
    equalsFunc: (a, b) => a === b,
};
export default function useSet(_config = {}) {
    const config = React.useMemo(() => (Object.assign(Object.assign({}, DEFAULT_CONFIG), _config)), [_config]);
    // Always use current version of equals function, don't cause re-renders when equal function changes.
    const equalsRef = React.useRef(config.equalsFunc || DEFAULT_CONFIG.equalsFunc);
    const { equalsFunc: configEqualsRef } = config;
    React.useEffect(() => {
        if (configEqualsRef) {
            equalsRef.current = configEqualsRef;
        }
    }, [configEqualsRef]);
    const [items, setItems] = React.useState(config.initialValue);
    const includes = React.useCallback((arr, val) => arr.some((a) => equalsRef.current(a, val)), []);
    const has = React.useCallback((val) => Array.isArray(val)
        ? val.every((v) => includes(items, v))
        : includes(items, val), [includes, items]);
    const add = React.useCallback((val) => {
        setItems((i) => i.concat((Array.isArray(val) ? val : [val]).filter((v) => !includes(i, v))));
    }, [includes]);
    const remove = React.useCallback((val) => {
        setItems((it) => it.filter((i) => !includes(Array.isArray(val) ? val : [val], i)));
    }, [includes]);
    const clear = React.useCallback((vals = []) => {
        setItems(vals);
    }, []);
    return React.useMemo(() => ({
        has,
        add,
        remove,
        clear,
        values: items,
        size: items.length,
    }), [add, clear, remove, has, items]);
}
